// import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import Header from "./Header";
// import FootIcons from "./FootIcons";
// import Footer from "./Footer";
// import Hero from "./Hero";
// import Chat from "./Chat";
// import Call from "./Call";
// import AstroProfile from "./AstroProfile";
// import Following from "./Following";
// import Chatbot from "./Chatbot";
// import AstroKundli from "./AstroKundli";
// import Horoscope from "./Horoscope";
// import AstrologersTalk from "./AstrologersTalk";
// import AstrologersCallPage from "./AstrologersCallPage";
// import About from "./About";
// import Error from "./Error";
// import ZodiacSign from "./ZodiacSign";
// import Login from "./Login";
// import PrivateRoute from "./PrivateRoute";
// import Logout from "./Logout";
// import EditDetail_Res from "./EditDetail_Res";

// const Body = () => {
//   return (
//     <BrowserRouter>
//       <SignupRedirect /> {/* Move redirect logic inside the Router */}
//       <Header />
//       <FootIcons />
//       <Routes>
//         <Route path="/" element={<Hero />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/logout" element={<Logout />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/error" element={<Error />} />
//         <Route path="/zodiacSign" element={<ZodiacSign />} />
//         <Route path="/edit_profile" element={<EditDetail_Res />} />

//         {/* Protected Routes */}
//         <Route element={<PrivateRoute />}>
//           <Route path="/chat" element={<Chat />} />
//           <Route path="/call" element={<Call />} />
//           <Route path="/astroProfile/:id" element={<AstroProfile />} />
//           <Route path="/following" element={<Following />} />
//           <Route path="/chatbot" element={<Chatbot />} />
//           <Route path="/aikundali" element={<AstroKundli />} />
//           <Route path="/horoscope/:id" element={<Horoscope />} />
//           <Route path="/astrologerschat/:id" element={<AstrologersTalk />} />
//           <Route path="/astrologerscall" element={<AstrologersCallPage />} />
//         </Route>
//       </Routes>
//       <Footer />
//     </BrowserRouter>
//   );
// };

// // Redirect Component
// const SignupRedirect = () => {
//   const signup_profile = Cookies.get("signup_profile");
//   const user = Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null;

//   if (signup_profile && user) {
//     return <Navigate to="/edit_profile" replace />;
//   }

//   return null;
// };

// export default Body;







import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./Header";
import FootIcons from "./FootIcons";
import Footer from "./Footer";
import Hero from "./Hero";
import Chat from "./Chat";
import Call from "./Call";
import AstroProfile from "./AstroProfile";
import Following from "./Following";
import Chatbot from "./Chatbot";
import AstroKundli from "./AstroKundli";
import Horoscope from "./Horoscope";
import AstrologersTalk from "./AstrologersTalk";
import AstrologersCallPage from "./AstrologersCallPage";
import About from "./About";
import Error from "./Error";
import ZodiacSign from "./ZodiacSign";
import Login from "./Login";
import PrivateRoute from "./PrivateRoute";
import Logout from "./Logout";
import EditDetail_Res from "./EditDetail_Res";
import SignupRedirect from "./SignupRedirect"; // Import the redirect component

const Body = () => {
  return (
    <BrowserRouter>
      <SignupRedirect /> {/* Handles automatic redirection */}
      <Header />
      <FootIcons />
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/about" element={<About />} />
        {/* <Route path="/*" element={<Error />} /> */}
        <Route path="/zodiacSign" element={<ZodiacSign />} />

        {/* Protected Routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/chat" element={<Chat />} />
          <Route path="/call" element={<Call />} />
          <Route path="/astroProfile/:id" element={<AstroProfile />} />
          <Route path="/following" element={<Following />} />
          <Route path="/chatbot" element={<Chatbot />} />
          <Route path="/aikundali" element={<AstroKundli />} />
          <Route path="/horoscope/:id" element={<Horoscope />} />
          <Route path="/astrologerschat/:id" element={<AstrologersTalk />} />
          <Route path="/astrologerscall" element={<AstrologersCallPage />} />
          <Route path="/edit_profile" element={<EditDetail_Res />} />
        </Route>
        <Route path="/*" element={<Error />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default Body;

